import { ClientId, FeaturesByClientIds, FeaturesValues } from './constants';

type FeatureByClientId = `is${FeaturesValues}`;
type GetFeaturesByClientId = Record<FeatureByClientId, boolean>;

export const getFeaturesByClientId = (clientId: ClientId): GetFeaturesByClientId => {
  return {
    isBypassGuidedSignIn: FeaturesByClientIds.BYPASS_GUIDED_SIGN_IN.includes(clientId),
    isHideForgotPasswordLink: FeaturesByClientIds.HIDE_FORGOT_PASSWORD_LINK.includes(clientId),
    isAllowOktaSignInWithRedirect: FeaturesByClientIds.ALLOW_OKTA_SIGN_IN_WITH_REDIRECT.includes(clientId),
    isCloseActiveSession: FeaturesByClientIds.CLOSE_ACTIVE_SESSION.includes(clientId),
    isAllowOnlySignIn: FeaturesByClientIds.ALLOW_ONLY_SIGN_IN.includes(clientId),
    isDisplayMGMRewardsPromoBanner: FeaturesByClientIds.DISPLAY_MGM_REWARDS_PROMO_BANNER.includes(clientId),
  };
};
